import { useState } from "react";
import axios from "axios";
import { Send, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SERVICES = ["Marketing & Advertising", "Website Development", "Mobile App Development", "Not sure yet"];
const EMPTY = { name: "", email: "", phone: "", service: SERVICES[0], message: "", website: "" };

const Field = ({ label, id, children }) => (
  <label className="form-field" htmlFor={id}>
    <span>{label}</span>
    {children}
  </label>
);

export const InquiryForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    try {
      await axios.post(`${API}/inquiries`, form);
      setStatus("sent");
      setForm(EMPTY);
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Please check your details and try again.");
      setStatus("error");
    }
  };

  if (status === "sent") {
    return (
      <div className="inquiry-success" role="status" data-testid="inquiry-success">
        <CheckCircle2 size={40} aria-hidden="true" />
        <h3>Thank you, your inquiry was sent.</h3>
        <p>We'll get back to you soon.</p>
        <button type="button" className="link-btn" onClick={() => setStatus("idle")} data-testid="inquiry-send-another">
          Send another
        </button>
      </div>
    );
  }

  return (
    <form className="inquiry-form" onSubmit={submit} data-testid="inquiry-form">
      <h3 className="form-title">Tell us about your project</h3>
      <div className="form-grid">
        <Field label="Name" id="f-name">
          <input id="f-name" required minLength={2} maxLength={100} value={form.name} onChange={set("name")} autoComplete="name" data-testid="inquiry-name-input" />
        </Field>
        <Field label="Email" id="f-email">
          <input id="f-email" type="email" required value={form.email} onChange={set("email")} autoComplete="email" data-testid="inquiry-email-input" />
        </Field>
        <Field label="Phone (optional)" id="f-phone">
          <input id="f-phone" type="tel" maxLength={30} value={form.phone} onChange={set("phone")} autoComplete="tel" data-testid="inquiry-phone-input" />
        </Field>
        <Field label="Service" id="f-service">
          <select id="f-service" value={form.service} onChange={set("service")} data-testid="inquiry-service-select">
            {SERVICES.map((s) => <option key={s}>{s}</option>)}
          </select>
        </Field>
      </div>
      <Field label="Project details" id="f-message">
        <textarea id="f-message" required minLength={10} maxLength={3000} rows={5} value={form.message} onChange={set("message")} data-testid="inquiry-message-input" />
      </Field>
      <input className="hp" tabIndex={-1} autoComplete="off" aria-hidden="true" name="website" value={form.website} onChange={set("website")} />
      {status === "error" && <p className="form-error" role="alert" data-testid="inquiry-error">{error}</p>}
      <button type="submit" className="btn btn-gold form-submit" disabled={status === "sending"} data-testid="inquiry-submit-btn">
        {status === "sending" ? "Sending…" : "Send Inquiry"} <Send size={17} aria-hidden="true" />
      </button>
    </form>
  );
};
